(() => {
  let returnFocus;
  document.querySelectorAll('.lht-desktop-nav>a,.lht-mobile-nav>a').forEach(a=>{if(a.pathname===location.pathname && !a.search)a.setAttribute('aria-current','page');});
  document.addEventListener('click', event => {
    if(event.target.closest('[data-lht-back-to-product]')){event.preventDefault();document.querySelector('product-info')?.scrollIntoView({behavior:'smooth'});}
    const opener = event.target.closest('[data-lht-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.lhtOpen);
      if (!dialog) return;
      returnFocus = opener;
      opener.setAttribute('aria-expanded', 'true');
      dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-lht-close]');
    if (closer) closer.closest('dialog').close();
    const dialog = event.target.closest('.lht-dialog');
    if (dialog && event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right) dialog.close();
    }
    const arrow = event.target.closest('[data-lht-scroll]');
    if (arrow) {
      const track = document.getElementById(arrow.dataset.lhtTarget);
      if (track) track.scrollBy({left: track.clientWidth * Number(arrow.dataset.lhtScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    document.querySelectorAll('.lht-desktop-nav details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
    if (event.target.closest('.lht-dialog a')) dialog?.close();
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('.lht-dialog')) return;
    returnFocus?.setAttribute('aria-expanded', 'false');
    returnFocus?.focus();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.lht-desktop-nav details[open]').forEach(details => {
        details.open = false;
        details.querySelector('summary').focus();
      });
    }
  });
})();

(() => {
 const initialize = (scope=document) => {
  for (const track of scope.querySelectorAll('.lht-product-track')) {
   if(track.dataset.lhtBound) continue; track.dataset.lhtBound='true';
   const sync=()=>{const section=track.closest('.lht-shelf'); const max=track.scrollWidth-track.clientWidth;
    for(const button of section.querySelectorAll('[data-lht-scroll]')) button.disabled=Number(button.dataset.lhtScroll)<0 ? track.scrollLeft<=2 : track.scrollLeft>=max-2;
   };
   track.addEventListener('scroll',sync,{passive:true}); const observer = new ResizeObserver(sync); observer.observe(track);
   track.lhtCleanup = () => {observer.disconnect();track.removeEventListener('scroll',sync);delete track.dataset.lhtBound;}; sync();
  }
 };
 initialize(); document.addEventListener('shopify:section:load',event=>initialize(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.lht-product-track').forEach(track=>track.lhtCleanup?.()));
})();
if (!customElements.get('lht-comparison')) customElements.define('lht-comparison',class extends HTMLElement{connectedCallback(){this.input=this.querySelector('input');this.update=()=>{this.style.setProperty('--reveal',`${this.input.value}%`);this.input.setAttribute('aria-valuetext',`${this.input.value}% ${this.querySelector('.lht-comparison-label--left').textContent}`)};this.input.addEventListener('input',this.update);this.update()}disconnectedCallback(){this.input?.removeEventListener('input',this.update)}});

if (!customElements.get('lht-sticky-product')) {
 customElements.define('lht-sticky-product', class extends HTMLElement {
  connectedCallback() {
   this.owner = this.closest('product-info');
   this.action = this.querySelector('button');
   this.original = this.owner?.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
   if (!this.original) return;
   this.sync = () => {
    this.action.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
    this.action.querySelector('span').textContent = this.original.querySelector('span')?.textContent.trim();
    const price = this.owner.querySelector('[id^="price-"] .price--on-sale .price-item--sale') || this.owner.querySelector('[id^="price-"] .price-item--regular');
    if (price) this.querySelector('[data-sticky-price]').textContent = price.textContent.trim();
    const error = this.owner.querySelector('.product-form__error-message-wrapper:not([hidden])');
    if (error) error.scrollIntoView({behavior:'smooth',block:'center'});
   };
   this.submit = () => { if (!this.action.disabled) this.original.click(); };
   this.action.addEventListener('click',this.submit);
   this.updateVisibility = () => { this.hidden = this.original.getBoundingClientRect().bottom > 0; };
   this.onScroll = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = null; this.updateVisibility(); });
   };
   window.addEventListener('scroll', this.onScroll, {passive:true});
   this.visibility = new IntersectionObserver(this.updateVisibility);
   this.updateVisibility();
   this.visibility.observe(this.original);
   this.state = new MutationObserver(changes => { if (changes.some(change => !this.contains(change.target))) this.sync(); });
   this.state.observe(this.owner,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','hidden']});
   this.sync();
  }
  disconnectedCallback() {
   this.action?.removeEventListener('click',this.submit);
   this.visibility?.disconnect(); this.state?.disconnect();
   window.removeEventListener('scroll', this.onScroll);
   if (this.frame) cancelAnimationFrame(this.frame);
  }
 });
}

// Start loading the next section before it enters view; exclude failed home cards.
(() => {
 const header=document.querySelector('.lht-header-section');
 const syncHeader=()=>header?.classList.toggle('is-compact',window.scrollY>80);
 window.addEventListener('scroll',syncHeader,{passive:true});syncHeader();
 const initializeMedia=(scope=document)=>{
  const observer=new IntersectionObserver(entries=>{
   for(const entry of entries) if(entry.isIntersecting){
    for(const img of entry.target.querySelectorAll('img[loading="lazy"]')) img.loading='eager';
    observer.unobserve(entry.target);
   }
  },{rootMargin:'1200px 0px'});
  scope.querySelectorAll('.lht-shelf,.lht-more').forEach(section=>observer.observe(section));
  scope.querySelectorAll('.lht-product-track [data-lht-product-id] img').forEach(img=>{
   const hideFailedCard=()=>{const card=img.closest('[data-lht-product-id]');if(card){card.hidden=true;const shelf=card.closest('.lht-shelf');if(!shelf.querySelector('[data-lht-product-id]:not([hidden])'))shelf.hidden=true;}};
   img.addEventListener('error',hideFailedCard,{once:true});
   if(img.complete && img.naturalWidth===0)hideFailedCard();
  });
 };
 initializeMedia();document.addEventListener('shopify:section:load',e=>initializeMedia(e.target));
})();
